import styled from 'styled-components';
import { Input, InputProps } from '../Input/Input';
import { pxToRem } from '@gif/shared-global';

const Wrapper = styled.div`
  display: flex;
`;

const DateInput = styled(Input)`
  margin-right: ${pxToRem(16)};
  &:last-of-type {
    margin-right: 0;
  }
  input {
    width: 100%;
  }
`;

export interface DateInputsProps {
  monthInputAttrs?: InputProps;
  dayInputAttrs?: InputProps;
  yearInputAttrs?: InputProps;
}

export const DateInputs = (props: DateInputsProps) => {
  const { monthInputAttrs, dayInputAttrs, yearInputAttrs, ...rest } = props;
  return (
    <Wrapper {...rest}>
      <DateInput {...monthInputAttrs} />
      <DateInput {...dayInputAttrs} />
      <DateInput {...yearInputAttrs} />
    </Wrapper>
  );
};

export default DateInputs;
